import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { EurotaxListDialogComponent } from '../components/calculatekfz/eurotax-list-dialog/eurotax-list-dialog.component';
import { RisikoKfzComponent } from '../components/calculatekfz/risikokfz/risikokfz.component';
import { IEuroTaxResult } from '../models/eurotaxresult';

@Injectable({
  providedIn: 'root'
})
export class EurotaxListDialogService {

  constructor(private dialog: MatDialog) { }

  openDialog(event: any, risikoKfzComponent: RisikoKfzComponent) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '80%';
    dialogConfig.height = '80%';

    dialogConfig.data = {
      expertMode: risikoKfzComponent.expertMode,
      motorrad: risikoKfzComponent.motorrad
    };

    const dialogRef = this.dialog.open(EurotaxListDialogComponent, dialogConfig);
    risikoKfzComponent.pingEurotax();
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadEurotax(result, risikoKfzComponent);
      }
    });
    event.preventDefault();
  }

  loadEurotax(result: IEuroTaxResult, risikoKfzComponent: RisikoKfzComponent) {
    risikoKfzComponent.loadEurotax(result);
  }
}
